import { Component, OnInit, ChangeDetectorRef, OnDestroy, ViewChild, Directive, HostListener } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { LoadingService } from '../../../shared/services/loading.service';
import { TranslateService } from '../../../translate';
import { AppService } from '../../../app.service';
import { SelectionLists, CurrentSelection, Equipment, Customer, JobSite, Make, ActionType } from '../../../entities';
import { Observable } from 'rxjs/Observable';
import { ManageEquipmentService } from '../../manage-equipment/manage-equipment.service';
import { EquipmentDetails } from '../../manage-equipment/models/manage-equipment.model';
import { trigger, style, transition, animate, keyframes, query, stagger } from '@angular/animations';
import { AvailableActionViewModel, ActionSystemViewModel, ComponentOnSystemViewModel, AvailableSystemToBeAReplacementViewModel, ReplacementCompartmentViewModel, SystemReplaceAction, GeneralActionViewModel, SystemReplacementWillEffectFutureActionsWarningViewModel, ReplacingComponentsOnSystemViewModel, MultipleComponentActionRequest } from '../action-models';
import { SystemActionsComponent } from './system-actions/system-actions.component';
import { ActionService } from '../action.service.service';
import moment from 'moment';
import { debounceTime } from 'rxjs/operators';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { CreateMultipleSystemComponentsComponent } from './create-multiple-system-components/create-multiple-system-components.component';
import { PreferencesService } from '../../preferences/preferences.service';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { StepperSelectionEvent } from '@angular/cdk/stepper';

@Component({
  selector: 'app-record-action',
  templateUrl: './record-action.component.html',
  styleUrls: ['./record-action.component.scss'],
  animations: [

    trigger('fadeInList', [
      transition('* => *', [
        query(':enter', style({ opacity: 0 }), { optional: true }),
        query(':enter', stagger('500ms', [
          animate('.5s ease-in', keyframes([
            style({ opacity: 0, transform: 'translateY(-5%)', offset: 0 }),
            style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
          ]))]), { optional: true })
      ])
    ]),
    trigger('listAnimation', [
      transition('* => *', [
        query(':enter', style({ opacity: 0 }), { optional: true }),
        query(':enter', stagger('500ms', [
          animate('.5s ease-in', keyframes([
            style({ opacity: 0, transform: 'translateY(-75%)', offset: 0 }),
            style({ opacity: 1, transform: 'translateY(0)', offset: 1.0 }),
          ]))]), { optional: true })
      ])
    ]),
    trigger(
      'fadeIn', [
        transition(':enter', [
          style({ opacity: 0 }),
          animate('500ms', style({ opacity: 1 }))
        ]),
        transition(':leave', [
          style({ opacity: 1 }),
          animate('500ms', style({ opacity: 0 }))
        ])
      ]
    )
  ],

  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ],
  
  })
  //  @Directive({
  //   selector: 'mat-vertical-stepper'
  //  })
export class RecordActionComponent implements OnInit, OnDestroy {
  translateSubscription: Subscription;
  userLanguage = 'english';
  _loadingSelections = false;
  _loadingEquipment = false;
  _loadedSelection = false;
  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
  _currentSelection: CurrentSelection = new CurrentSelection();
  _returnRoute = '';
  _selectedEquipment: EquipmentDetails = new EquipmentDetails();
  equipmentId: number;

  _selectedIndex = 0;

  succesfullySubmitted = false;

  equipmentSelectionLocked: boolean;

  _actioning  = false;

  step1Submitted= false;
  isReplaceAction= false;

  isChainAction: boolean;
  isFrameAction: boolean;

  selectedAction: AvailableActionViewModel;
  selectedComponent: ComponentOnSystemViewModel;
  selectedSystem: ActionSystemViewModel;


  availableSystemReplacements: AvailableSystemToBeAReplacementViewModel[];
  availableComponentReplacements: ReplacementCompartmentViewModel[];
  newSystemId: number;
  oldSystemId: number;


  action = new GeneralActionViewModel();

  @ViewChild('LeftChain')
  leftChainSystem: SystemActionsComponent;

  @ViewChild('RightChain')
  rightChainSystem: SystemActionsComponent;

  @ViewChild('LeftFrame')
  leftFrameSystem: SystemActionsComponent;

  @ViewChild('RightFrame')
  rightFrameSystem: SystemActionsComponent;




  @ViewChild('multipleSystemReplacementComponent')
  repalceMutipleComponentsView: CreateMultipleSystemComponentsComponent;

  public today = new Date();
//new code
part:number=0;
//end new code

  stepOneErrorMessage = '';
  stepTwoErrorMessage = '';
  stepThreeErrorMessage = '';
  stepFourErrorMessage = '';

  oldSystemDisplayView: AvailableSystemToBeAReplacementViewModel;
  newSystemDisplayView: AvailableSystemToBeAReplacementViewModel;
  newComponentView: ComponentOnSystemViewModel;

  futureActionsOnOldSystemThatBelongsToNewSystem: SystemReplacementWillEffectFutureActionsWarningViewModel;
  futureActionsOnNewSystem: SystemReplacementWillEffectFutureActionsWarningViewModel;

  displayedColumns: string[] = [ 'ActionDate', 'ActionTypeName', 'OldActualLife' ];
  newSystemDataSource =  new MatTableDataSource();
  oldSystemDataSource =  new MatTableDataSource();

  LabourCostOptions = [{ Id: 0, Name: 'Dollar' }, { Id: 1, Name: 'Hourly' }];

  labourCostLableTitle = 'Labour Cost';
  cutomerHourlyRate = 0;
  needToInputHourlyRate = false;


  navigated = false;

  //appUris: AppUris;
  DateControl: FormControl;
  SMUControl: FormControl;
  PMUControl: FormControl;

  LabourCostOpControl: FormControl;

  //MakeControl: FormControl;

  BudgetLifeControl: FormControl;
  PartCostControl: FormControl;
  LabourCostControl: FormControl;
  MiscCostControl: FormControl;
  //CommentControl: FormControl;
  HourlyRateControl:FormControl;
  ReedControl: FormControl;
  ReedPMUControl: FormControl;


  ExtendedBudgetLifeControl: FormControl;
  Makes: Make[] = [];

  componentActionOnSystem: ActionSystemViewModel;
  allRollers: ComponentOnSystemViewModel[];


  isReplacingMultipleComponentsAtOnce = false;

  additionalStepErrorMessage = '';

  actionForm: FormGroup;
  selectedSystemSide: number;


  replacementSucessful = false;

  selectLeftButton:boolean=false;
  selectRightButton:boolean=false;
  selectedSide:number=0;
  sideName:string;
  showChain:boolean=false;
  showFrame:boolean=false;
  showDiv:boolean=false;
  replaceChainSystem:boolean=false;
  replaceFrameSystem:boolean=false;
  typeId:number;
  replace:boolean=false;
  isReplaceNew:boolean=false
  isReplaceNewChain:boolean=false
  isReplaceNewFrame:boolean=false
  systemActions: AvailableActionViewModel[] = [];
  system: ActionSystemViewModel;
  systemList: ActionSystemViewModel[]=[];
  isReplaceMultiple:boolean=false;
  constructor(
    private _appService: AppService,
    private _router: Router,
    private ref: ChangeDetectorRef,
    private _translate: TranslateService,
    private _formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    private _notification: NotificationsService,
    private _route: ActivatedRoute,
    private _loadingService: LoadingService,
    private _equipmentService: ManageEquipmentService,
    private _sanitizer: DomSanitizer,
    private _actionService: ActionService,
    private _dialog: MatDialog,
    private readonly _pref: PreferencesService,
    ) {
  }
  @ViewChild(MatStepper)
  private stepper: MatStepper;
  //@HostListener('selectionChange', ['$event'])

  selectionChanged(selection: StepperSelectionEvent) {
    const stepId = this.stepper._getStepLabelId(selection.selectedIndex);
    const stepElement = document.getElementById(stepId);
    if (stepElement) {
      setTimeout(() => {
        stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
      }, 250);
    }
  }

   scrollToSectionHook() { 
    const stepId = this.stepper._getStepLabelId(this.stepper.selectedIndex);
    const stepElement = document.getElementById(stepId);
    if (stepElement) {
      setTimeout(() => {
        stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
      }, 250);
    }
  }


  ngOnInit() {
    this._appService.setPageTitle('Record Action');

    this.equipmentId = +this._route.snapshot.paramMap.get('id');
    this.newSystemId = +this._route.snapshot.paramMap.get('id2');
    this.oldSystemId = +this._route.snapshot.paramMap.get('id3');
    if (this.equipmentId !== 0 && this.equipmentId !== undefined && this.newSystemId !==0 && this.newSystemId !== undefined)  {
      this._selectedIndex = 2;
      this.SMUControl = new FormControl(this.SMUControl, [ Validators.required]);
      this.PMUControl = new FormControl(this.PMUControl, []);
      this.ReedControl = new FormControl(this.ReedControl, []);
      this.ReedPMUControl = new FormControl(this.ReedPMUControl, []);
      this.PartCostControl = new FormControl(this.PartCostControl, []);
      this.LabourCostControl = new FormControl(this.LabourCostControl, []);
      this.MiscCostControl = new FormControl(this.MiscCostControl, []);
      this.LabourCostOpControl = new FormControl(this.LabourCostOpControl, []);
      this.HourlyRateControl = new FormControl(this.HourlyRateControl, []);
      this.DateControl = new FormControl(this.DateControl,[ Validators.required]);
      this.BudgetLifeControl = new FormControl(this.BudgetLifeControl, []);
      this.actionForm = new FormGroup({
        SMUControl : this.SMUControl,
        PMUControl : this.PMUControl,

        
        PartCostControl : this.PartCostControl,
        LabourCostControl:this.LabourCostControl,
        MiscCostControl:this.MiscCostControl,
        LabourCostOpControl:this.LabourCostOpControl,
        HourlyRateControl:this.HourlyRateControl,
        DateControl:this.DateControl,
        ReedControl: this.ReedControl,
        ReedPMUControl:this.ReedPMUControl,
        BudgetLifeControl:this.BudgetLifeControl,
      })

    
      
      this.loadEquipment(this.equipmentId);
    }else if (this.equipmentId !== 0 && this.equipmentId !== undefined ) {
      this.navigated = true;
      this.loadEquipment(this.equipmentId);
    }else {
      this.loadSelection();
    }

    //this._appService.getAppUris().subscribe(result => { this.appUris = result; });
    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));

    this._actionService.GetComponentReplacementBrends().subscribe(result => {
      this.Makes = result;
      this._loadingService.finishedLoading();
    },
    error => { console.error(error); }, );

    this.SMUControl = new FormControl(this.SMUControl, [ Validators.required]);
    this.PMUControl = new FormControl(this.PMUControl, []);

    this.DateControl = new FormControl( moment( new Date(this.action.ActionDate) ), [ Validators.required]);
    this.BudgetLifeControl = new FormControl(this.action.BudgetLife, []);
    this.PartCostControl = new FormControl(this.action.PartCost, []);
    this.LabourCostControl = new FormControl(this.LabourCostControl, []);
    this.MiscCostControl = new FormControl(this.action.MiscCost, []);
    //this.CommentControl = new FormControl(this.action.Comment, []);
    this.LabourCostOpControl = new FormControl(this.action.LabourCostOption, []);
    this.ReedControl = new FormControl(this.action.Reed, []);
    this.ReedPMUControl = new FormControl(this.action.ReedPMU, []);

 
    this.HourlyRateControl = new FormControl(this.HourlyRateControl,[]);
    //this.MakeControl = new FormControl(this.action.MakeId, []);
    this.ExtendedBudgetLifeControl = new FormControl(this.action.ExtendedBudgetLife, []);
    this.actionForm = new FormGroup({
      SMUControl : this.SMUControl,
      PMUControl : this.PMUControl,
      DateControl : this.DateControl,
      BudgetLifeControl: this.BudgetLifeControl,
      PartCostControl: this.PartCostControl,
      LabourCostControl: this.LabourCostControl,
      MiscCostControl: this.MiscCostControl,
      //CommentControl: this.CommentControl,
      LabourCostOpControl: this.LabourCostOpControl,
      //MakeControl: this.MakeControl,
      ReedControl: this.ReedControl,
      ReedPMUControl:this.ReedPMUControl,
      HourlyRateControl:this.HourlyRateControl,
      ExtendedBudgetLifeControl: this.ExtendedBudgetLifeControl,

    });

    Object.keys(this.actionForm.controls).forEach(key => {
      const control  = this.actionForm.get(key);
      if ( key !== 'DateControl' && key !== 'SMUControl' )return;
      control.valueChanges.pipe(debounceTime(1000))
      .map(
        a => {

        })
      .subscribe(
        () => {
          if (this.newSystemId === 0 || this.oldSystemId === 0 || this.action.NewSMU === null || this.action.NewSMU === undefined || (!this.isReplaceAction || this.selectedSystem === undefined)) return;
          const newSystemActions = this._actionService.getFutureActionsForNewSystem( this.oldSystemId, this.newSystemId, this.equipmentId, this.action.ActionDate, this.action.NewSMU);
          const oldSystemActions = this._actionService.getFutureActionsForOldSystem( this.oldSystemId, this.newSystemId, this.equipmentId, this.action.ActionDate, this.action.NewSMU);
          this._loadingService.startLoading();
          Observable.forkJoin(newSystemActions, oldSystemActions).subscribe(result => {
//console.log("this.futureActionsOnOldSystemThatBelongsToNewSystem",this.futureActionsOnOldSystemThatBelongsToNewSystem)
            this.futureActionsOnOldSystemThatBelongsToNewSystem = result[0];
            this.oldSystemDataSource.data = this.futureActionsOnOldSystemThatBelongsToNewSystem.ActionsWillBeEffected;
            this.futureActionsOnNewSystem = result[1];
            this.newSystemDataSource.data = this.futureActionsOnNewSystem.ActionsWillBeEffected;
          }, error => { console.error(error); },
          () => { this._loadingService.finishedLoading();  });
        }
      );
    });

 }
//new code with TT-1629 changes 


loadSystem(value:number){
 // console.log("side selected",this.selectedSide)
  this._actionService.GetActionSystemViews(this.equipmentId, value,this.selectedSide).subscribe((s: any) => {
    this.system = s;
    //console.log(" this.system",  this.system)
     // this.selectedSystem =this.system;
    if(this.isReplaceNew==true){
      
      this.selectedSystem=this.system;
      this.setupNewInInventory()
    } 

    if(this.isReplacingMultipleComponentsAtOnce==true){
    
      this.selectedSystem=this.system;
     this.step1()
    } 
  })
 
}
selectLeftSide(){
  this.isReplaceNew=false
  this.selectLeftButton=true;
  this.selectRightButton=false;
  this.selectedSide=1
  this.sideName="Left"
}
selectRighttSide(){
  this.isReplaceNew=false
  this.selectLeftButton=false;
  this.selectRightButton=true;
  this.selectedSide=2;
  this.sideName="Right"
}
IndiviualComponentAction(SystemTypeId:number){
  this.isReplaceMultiple=false
  this.isReplaceNew=false
  this.isReplaceNewChain=false
  this.isReplaceNewFrame=false
  if(this.replaceChainSystem==true ||this.replaceFrameSystem==true ){
    this.unlockAction();
    this.replace =false;
  }
  this.showDiv=false;
  if(SystemTypeId==1){
    this.showChain=true;
    this.showFrame=false;
    this.showDiv=true;
    this.typeId=1;
    this.replaceChainSystem=false;
    this.replaceFrameSystem=false;
  }
    else{
      this.showFrame=true;
      this.showChain=false;
      this.showDiv=true
      this.typeId=2;
      this.replaceChainSystem=false;
      this.replaceFrameSystem=false;
    }
 
 
}

ReplaceFromInv(SystemTypeId:number){
  this.isReplaceMultiple=false
  this.isReplaceNew=false;
  this.isReplaceNewFrame=false
  this.isReplaceNewChain=false
  this.replace =true;
  this.selectedComponent =undefined;
if (SystemTypeId === 1) {
    this.showChain=true;
    this.showFrame=false;
    this.showDiv=true;
    this.typeId=1;
    this.replaceChainSystem=true;
    this.replaceFrameSystem=false;
   
    this.isChainAction=true
    this.isFrameAction=false
  this.selectedAction = 
    new AvailableActionViewModel(34, `Replace ${SystemTypeId === 1 ? 'Chain' : 'Frame'} `)
    //this.loadSystem(SystemTypeId);
}    else {
 
      this.showFrame=true;
      this.showChain=false;
      this.showDiv=true
      this.typeId=2;
      this.replaceChainSystem=false;
      this.replaceFrameSystem=true;
      this.isChainAction=false
    this.isFrameAction=true
  this.selectedAction = 
    new AvailableActionViewModel(34, `Replace ${SystemTypeId === 1 ? 'Chain' : 'Frame'} `)
  
}
  this.loadSystem(SystemTypeId);
}

ReplaceNew(SystemTypeId:number){
  this.isReplaceMultiple=false
  this.isReplaceNew=true;
  this.replace =true;
  this.selectedComponent =undefined;
if (SystemTypeId === 1) {
    this.showChain=true;
    this.showFrame=false;
    this.showDiv=true;
    this.typeId=1;
    this.replaceChainSystem=true;
    this.replaceFrameSystem=false;
    this.isReplaceNewChain=true
    this.isChainAction=true
    this.isFrameAction=false
  this.selectedAction = 
    new AvailableActionViewModel(34, `Replace ${SystemTypeId === 1 ? 'Chain' : 'Frame'} `)
  
}    else {
      this.isReplaceNewFrame=true
      this.showFrame=true;
      this.showChain=false;
      this.showDiv=true
      this.typeId=2;
      this.replaceChainSystem=false;
      this.replaceFrameSystem=true;
      this.isChainAction=false
    this.isFrameAction=true
  this.selectedAction = 
    new AvailableActionViewModel(34, `Replace ${SystemTypeId === 1 ? 'Chain' : 'Frame'} `)
  
}
this.loadSystem(SystemTypeId);


}


MultipleComponent(SystemTypeId:number){
  
  this.selectedSystemSide = this.selectedSide;
  this.isReplaceMultiple=true;
      this.showFrame=true;
      this.showChain=false;
      this.showDiv=true
      this.typeId=2;
      this.replaceChainSystem=false;
      this.replaceFrameSystem=true;
      this.isChainAction=false
    this.isFrameAction=true
  this.selectedAction = 
  new AvailableActionViewModel(600, `Replace Multiple ${this.selectedSide === 1 ? 'Left' : 'Right'}  Components`)
  this.loadSystem(SystemTypeId);
 
  this.isReplacingMultipleComponentsAtOnce=true

}
///end new code for TT-1629////
 loadEquipment(equipmentId: number) {
 // console.log("stepppp",this.newSystemId)
    this._loadingService.startLoading();
    this._loadingEquipment = true;
    this.equipmentSelectionLocked = true;
    this._equipmentService.getEquipmentDetails(equipmentId).subscribe(e => {
      this._selectedEquipment = e;
      this._currentSelection.customer.Id = this._selectedEquipment.CustomerId;
      this._currentSelection.customer.Title = this._selectedEquipment.CustomerName;
      this._currentSelection.jobSite.Id = this._selectedEquipment.JobsiteId;
      this._currentSelection.jobSite.Title = this._selectedEquipment.JobsiteName;
      this._currentSelection.jobSite.CustomerId = this._selectedEquipment.CustomerId;
      this._loadingEquipment = false;
      this.equipmentSelectionLocked = true;
      
      if (this.newSystemId !== 0 && this.newSystemId !== undefined) {
       
        this._actionService.getSystemViewForDisplay(this.oldSystemId).subscribe(r => {
          this.oldSystemDisplayView = r;
           //console.log("SYstemView", this.oldSystemDisplayView)
           this.oldSystemId = this.oldSystemId;
          this.ReplaceFromInv(this.oldSystemDisplayView.SystemType)
         // this.disableAllActionSelection(1, this.oldSystemId)
          this.selectedSystem.SystemId = this.oldSystemId;
          this.checkActionType(false);
        
        
        });
        
       
      } else if (this.navigated) {
       
        this.step0();
      }
     
      if ( this.Makes.filter( a => a.Title === this._selectedEquipment.Make ).length === 0) {
        this._actionService.getExtraMakeOfThisEquipment(this.equipmentId).subscribe(m =>          {
          this.Makes.unshift(m);
          });
      }
    }, error => { this.equipmentSelectionLocked = false; this._loadingService.finishedLoading(); });

    this._loadingService.finishedLoading();
 }

 loadSelection() {
  if (this._loadedSelection) return;
  this._loadingService.startLoading();
  this._loadingSelections = true;
  this.equipmentSelectionLocked = false;
  const customersQuery =  this._appService.getCustomerListForSelection(1, 10000);
  const jobsitesQuery =   this._appService.getJobSiteListForSelection(1, 10000);
  const equipmentsQuery = this._appService.getEquipmentListForSelection(1, 10000);

  Observable.forkJoin([customersQuery, jobsitesQuery, equipmentsQuery]).subscribe(results => {
    this._dropDownLists.customerList = results[0];
    this._dropDownListsFiltered.customerList = results[0];
    this._dropDownLists.jobSiteList = results[1];
    this._dropDownLists.equipmentList = results[2];
    this._loadingSelections = false;
    this._loadedSelection = true;
    this._loadingService.finishedLoading();
  }, error => { console.error(error); });
 }

  ngOnDestroy() {
    this.translateSubscription.unsubscribe();
  }

  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  customerChanged(event: any): void {
    const customer: Customer = event.value;
    if (!customer) return;
    this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(m => m.CustomerId === customer.Id);
    this._currentSelection.jobSite = new JobSite();
    this._dropDownListsFiltered.equipmentList = [];
    this._currentSelection.equipment = new Equipment();
  }

  jobsiteChanged(event: any): void {
    const jobsite: JobSite = event.value;
    if (!jobsite) return;
    this._dropDownListsFiltered.equipmentList = this._dropDownLists.equipmentList.filter(m => m.JobSiteId === jobsite.Id);
    this._currentSelection.equipment = new Equipment();
  }

  equipmentChanged(event: any): void {
    this.equipmentId = event.value.Id;
    this.loadEquipment(this.equipmentId);
  }

  submit() {
  }

  swapRollerEvent(selectedRoller: ComponentOnSystemViewModel) {
    this.action.NewEqUnitId = selectedRoller.GeneralEqunitId;
  }

  reSelectEquipment() {
    this.equipmentSelectionLocked = false;
    this.loadSelection();
    this.newSystemId = 0;
    this.newSystemDisplayView = undefined;
    this.oldSystemId = 0;
    this.oldSystemDisplayView = undefined;
    this._currentSelection.equipment = new Equipment();
  }

  step0(): boolean {
    if (this.equipmentId === 0 || this.equipmentId === undefined ) {
      this.stepOneErrorMessage = 'Please select an equipment to proceed';
      return false;
    } else {
      this.stepOneErrorMessage = '';
      this._selectedIndex = 1;
      return true;
    }
  }
  step1(): boolean {
    console.log(this.selectedSystem,"selectedSystem")

  
    if (this.selectedAction === undefined) {
      this.stepTwoErrorMessage = 'No Actions Selected';
      return false;
    } else
    if (this.selectedComponent === undefined && this.selectedSystem === undefined) {
      this.stepTwoErrorMessage = 'Please select a system or a component to perform action on';
      return false;
    }  else {
      this.stepTwoErrorMessage = '';
      this._selectedIndex = 2;
      this.SMUControl = new FormControl(this.SMUControl, [ Validators.required]);
      this.PMUControl = new FormControl(this.PMUControl, []);

      this.PartCostControl = new FormControl(this.PartCostControl, []);
      this.LabourCostControl = new FormControl(this.LabourCostControl, []);
      this.MiscCostControl = new FormControl(this.MiscCostControl, []);
      this.LabourCostOpControl = new FormControl(this.LabourCostOpControl, []);
      this.HourlyRateControl = new FormControl(this.HourlyRateControl, []);
      this.DateControl = new FormControl(this.DateControl, [ Validators.required]);
      
      this.actionForm = new FormGroup({
        SMUControl : this.SMUControl,
        PMUControl : this.PMUControl,

        PartCostControl : this.PartCostControl,
        LabourCostControl:this.LabourCostControl,
        MiscCostControl:this.MiscCostControl,
        LabourCostOpControl:this.LabourCostOpControl,
        HourlyRateControl:this.HourlyRateControl,
        DateControl:this.DateControl,
        ReedControl: this.ReedControl,
        ReedPMUControl:this.ReedPMUControl,
        BudgetLifeControl :this.BudgetLifeControl,
      })

      // if (this.isReplacingMultipleComponentsAtOnce) {
      //   this.getReplacingSystemInfo();
      // }
      return true;
    }
  }
  step2(): boolean {
    return true;
  }


  getReplacingSystemInfo() {

  }

  disableAllActionSelection(comeFromSystemSide: number, comeFromSystemType: number) {
    this.leftFrameSystem.disableAllActions();
    this.rightFrameSystem.disableAllActions();
    this.leftChainSystem.disableAllActions();
    this.rightChainSystem.disableAllActions();

    if (comeFromSystemType === 1 ) {
      this.isChainAction = true;
      this.isFrameAction = false;
    }
    if (comeFromSystemType === 2 ) {
      this.isChainAction = false;
      this.isFrameAction = true;
    }
  }

  unlockAction() {
    this.leftFrameSystem.reSelectActions();
    this.rightFrameSystem.reSelectActions();
    this.leftChainSystem.reSelectActions();
    this.rightChainSystem.reSelectActions();
    this.selectedAction = undefined;
    this.selectedComponent = undefined;
    this.selectedSystem = undefined;
    this.isChainAction = false;
    this.isFrameAction = false;
    this.newSystemId = 0;
    this.newSystemDisplayView = undefined;
    this.oldSystemId = 0;
    this.oldSystemDisplayView = undefined;
  }



  selectedComponentAction(event, side: number, systemType: number) {
    this.disableAllActionSelection(systemType, side);

    this.componentActionOnSystem = event.systemModel;
    this.selectedAction = event.actionModel;
    this.selectedComponent = event.componentModel;
    this.action.BudgetLife = event.componentModel.BudgetLife;
    
    this.action.LabourCost=0;
    this.action.PartCost=0;
    this.part=0;
    this.action.MiscCost=0;
    this.action.LabourCostOption=1;
    this.action.Comment=" ";
    this.action.ActionTypeId = this.selectedAction.ActionTypeId;
    this.allRollers = this.componentActionOnSystem.Components.filter(a => a.CompartTypeId === this.selectedComponent.CompartTypeId);

    this.checkActionType(true);
  }



  selectedSystemAction(event, side: number, systemType: number) {
    //console.log("selectedSystemAction",systemType,side,this.selectedAction);
    this.disableAllActionSelection(side, systemType );
    this.selectedSystemSide = side;
    // console.log("selectedSystemAction",systemType,side,this.selectedAction);
    this.selectedAction = this.selectedAction//event.actionModel;
    this.selectedSystem = this.system;//event.systemModel;
    this.action.ActionTypeId = this.selectedAction.ActionTypeId;
    this._actionService.getSystemViewForDisplay(this.selectedSystem.SystemId).subscribe(r => {
      this.oldSystemDisplayView = r;
      this.oldSystemId = this.selectedSystem.SystemId;
    });
    this.checkActionType(false);

if(this.selectedSystem !==undefined){
  this.stepTwoErrorMessage = '';
  this._selectedIndex = 2;
  // if (this.isReplacingMultipleComponentsAtOnce) {
  //   this.getReplacingSystemInfo();
  // }
  return true;
}

console.log("Old systm",this.oldSystemId, this.selectedSystem.SystemId )
  }



  checkActionType(isComponent: boolean) {
   
    if ( this.selectedAction.ActionTypeName.startsWith('Replace')) {
      this.isReplaceAction = true;
      if (isComponent) {
        this.getAvailableComponentReplacement();
        this.isReplacingMultipleComponentsAtOnce = false;
      } else {
        this.getAvailableSystemReplacement();
        if (this.selectedAction.ActionTypeId === 600) {
          this.isReplacingMultipleComponentsAtOnce = true;
        } else {
          this.isReplacingMultipleComponentsAtOnce = false;
        }
      }
    } else {
      this.isReplaceAction = false;
      this.isReplacingMultipleComponentsAtOnce = false;
    }
  }

  systemLoaded(event, comeFromSystemSide: number, comeFromSystemType: number) {
    
    console.log("systemInfo.....",comeFromSystemSide, comeFromSystemType, event, this.oldSystemId)
    this.systemList.push(event);
    this.oldSystemId = +this._route.snapshot.paramMap.get('id3');

    if ( this.oldSystemId === undefined) return;
    if ( this.oldSystemId !== undefined && event.SystemId === this.oldSystemId) {
      const systemReplaceProp = new SystemReplaceAction();
      if (comeFromSystemType === 1) {
        if (comeFromSystemSide === 1) {
          this.system=event;
          this.selectedSide = comeFromSystemSide;
          this.leftChainSystem.selectActionOnSystem( new AvailableActionViewModel(systemReplaceProp.ActionTypeId, systemReplaceProp.ActionTypeName),);
        } else
        if (comeFromSystemSide === 2) {
          this.system=event;
          this.selectedSide = comeFromSystemSide;
          this.rightChainSystem.selectActionOnSystem( new AvailableActionViewModel(systemReplaceProp.ActionTypeId, systemReplaceProp.ActionTypeName));
        }
    }
      if (comeFromSystemType === 2) {
        if (comeFromSystemSide === 1) {
          this.system=event;
          this.selectedSide = comeFromSystemSide;
          this.leftFrameSystem.selectActionOnSystem( new AvailableActionViewModel(systemReplaceProp.ActionTypeId, systemReplaceProp.ActionTypeName));
        } else
        if (comeFromSystemSide === 2) {
          this.system=event;
          this.selectedSide = comeFromSystemSide;
          this.rightFrameSystem.selectActionOnSystem( new AvailableActionViewModel(systemReplaceProp.ActionTypeId, systemReplaceProp.ActionTypeName));
        }
      }
    }
    //console.log("systemList", this.systemList)
  }


  //PartCost:number=0;
  currentTotalCost(): number {
    if(this.action.HourlyRate ==  undefined){
      this.action.HourlyRate = 0;
    }
    //console.log("totals HR Pa LAC Misc", this.action.HourlyRate, this.cutomerHourlyRate,this.action.PartCost , this.action.LabourCost , this.action.MiscCost)
    //console.log("Option",this.action.LabourCostOption )
    if (this.action.LabourCostOption === 0) {
      return (
        this.action.PartCost + this.action.LabourCost + this.action.MiscCost
      );
    }
    return (
      this.action.PartCost +  this.action.HourlyRate * this.action.LabourCost +  this.action.MiscCost
    );
  }



  labourCostOptionChanged(event) {
    //console.log("labourcost event",event, this.action)
    //if (this.action.LabourCostOption === 0) {
      if (event.value === 0) {
        this.action.LabourCostOption = 0;
      this.labourCostLableTitle = 'Labour Cost';
    } else {
      this.labourCostLableTitle = 'Hours';
      this.action.LabourCostOption = 1;
      this._actionService
        .getCustomerHourlyRate(this._selectedEquipment.CustomerId)
        .subscribe(r => {
          this.cutomerHourlyRate = r;
          this.action.HourlyRate = r;
          if (this.cutomerHourlyRate === 0 || this.cutomerHourlyRate < 0) {
            this.needToInputHourlyRate = true;
            this.action.HourlyRate = 0;
          }
        });
    }
  }

 selectedSystemId:number
  getAvailableSystemReplacement() {
    if (this.selectedSystem === undefined) return;
    this.selectedSystemId = this.selectedSystem.SystemId;
   // console.log("equiiii",this.equipmentId, this._currentSelection.jobSite.Id, this.isChainAction, this.selectedSystem.SystemId);
    this._actionService.getAvailbleSystemReplacement(this.equipmentId, this._currentSelection.jobSite.Id, this.isChainAction, this.selectedSystem.SystemId ).subscribe(r => {
      this.availableSystemReplacements = r;
      if (this.newSystemId !== 0 && this.newSystemId !== undefined) {
        this.selectedSystemReplacement({value : { SystemId: this.newSystemId}});
      }
    });
  }
  getAvailableComponentReplacement() {
    if (this.selectedComponent === undefined) return;
    this._actionService.getReplacementComponentOptions(this.selectedComponent.GeneralEqunitId).subscribe(c => {
      this.availableComponentReplacements = c;
      this.availableComponentReplacements = this.availableComponentReplacements.filter(x=>x.isChild==false);
    });
  }


  selectedSystemReplacement(event) {
    this.newSystemId = event.value.SystemId;
    this.pickedEventDate(this.action.ActionDate);
   
   // this.futureActionsOnOldSystemThatBelongsToNewSystem = undefined;
//console.log("olddd",  this.selectedSystemId, this.oldSystemId)
    const newSystemActions = this._actionService.getFutureActionsForNewSystem( this.oldSystemId, this.newSystemId, this.equipmentId, this.action.ActionDate, this.action.NewSMU);
    const oldSystemActions = this._actionService.getFutureActionsForOldSystem( this.oldSystemId, this.newSystemId, this.equipmentId, this.action.ActionDate, this.action.NewSMU);
    this._loadingService.startLoading();
    Observable.forkJoin(newSystemActions, oldSystemActions).subscribe(result => {
//console.log("this.futureActionsOnOldSystemThatBelongsToNewSystem",this.futureActionsOnOldSystemThatBelongsToNewSystem)
      this.futureActionsOnOldSystemThatBelongsToNewSystem = result[0];
      this.oldSystemDataSource.data = this.futureActionsOnOldSystemThatBelongsToNewSystem.ActionsWillBeEffected;
      this.futureActionsOnNewSystem = result[1];
      this.newSystemDataSource.data = this.futureActionsOnNewSystem.ActionsWillBeEffected;
    });


    this._actionService.getSystemViewForDisplay(event.value.SystemId).subscribe(r => {
      this._loadingService.finishedLoading();
      this.newSystemDisplayView = r;
    });

  }

   setupNewInInventory() {
   // console.log("this.replaceChainSystem", this.replaceChainSystem,"this.replaceFrameSystem",this.replaceFrameSystem )
    
    const enJobiteId = this._appService.simpleNumberEncrypt(this.selectedSystem.JobsiteId);
    const enSystemType = this._appService.simpleNumberEncrypt(this.replaceChainSystem ? 1 : this.replaceFrameSystem ? 2 : 0);
    const enEquipmentId = this._appService.simpleNumberEncrypt(this.equipmentId);
    const enSelectedSystem = this._appService.simpleNumberEncrypt(this.selectedSystem.SystemId);
    console.log(enSystemType, this.isChainAction);
     this._router.navigate(['setup-undercarriage/in-action', enJobiteId, enSystemType, enEquipmentId, enSelectedSystem]);
   // window.open( `${this.appUris.UCUri}/setup-undercarriage/in-inventory/${enJobiteId}/${enSystemType}/${enEquipmentId}/${enSelectedSystem} `, '_blank');
  }


  stepChangedManually(event) {
    //this.selectionChanged(event);
    this.scrollToSectionHook();
    console.log(event.selectedIndex);
    this._selectedIndex = event.selectedIndex;
    const backwardSteps: number = event.selectedIndex;
    const failedStep: number = event.selectedIndex;
  }

  getImage(image: string) {
    if (image != null && image !== undefined)
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

  translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  refreshReplacement() {
    console.log("old..", this.selectedSystem.SystemId)
    if (this.selectedSystem === undefined) return;
    this._loadingService.startLoading();
    this._actionService.getAvailbleSystemReplacement(this.equipmentId, this._currentSelection.jobSite.Id, this.isChainAction, this.selectedSystem.SystemId ).subscribe(r => {

      this.availableSystemReplacements = r;
      this._loadingService.finishedLoading();
    });

  }


  saveAction() {
    this._actioning = true;
    //console.log("save1",+this.action.ActionTypeId , +ActionType.ReplaceSystemFromInventory,this.action, this.newSystemId, this.oldSystemId, this.selectedSystem.SystemId);
    this.action.EquipmentId = this.equipmentId;
   
    this._loadingService.startLoading();
   
    if (+this.action.ActionTypeId === +ActionType.ReplaceSystemFromInventory || +this.action.ActionTypeId === 30) {
      this.action.ActionTypeId = +ActionType.ReplaceSystemFromInventory;

      this.oldSystemId =this.selectedSystem.SystemId ;
      this._actionService.SystemReplacement(this.action, this.newSystemId, this.oldSystemId,false).subscribe(a => {
        console.log("actionInfo", this.action, this.newSystemId, this.oldSystemId);
        this._loadingService.finishedLoading();

        if (a.OperationSucceed) {
          this.succesfullySubmitted = true;
          this._notification.success('System successfully replaced');
        } else {
          this._actioning = false;
          this._notification.error('System can not be replaced due to' + a.Message);
        }
      });
    } else {
      this.action.ActionEqUnitId = this.selectedComponent.GeneralEqunitId;
      this._actionService.PerformAction(this.action).subscribe(a => {
        this._loadingService.finishedLoading();
        if (a.OperationSucceed) {
          this.succesfullySubmitted = true;
          this._notification.success('Component action completed');
        } else {
          this._actioning = false;
          this._notification.error('Component action can not be performed.');
          console.log(a.Message);
        }
      });
    }

  }

  changeMake(event:any){
    //console.log("make", event)
    this.action.MakeId = event.value
  }


  CommentChange(event:any){
    console.log("comment___", event)
    this.action.Comment = event.target.value;
  }
  // shitty vaildation No time to implement reactive forms
  saveActionVaild(): boolean {
    
   // console.log("isreplace",this.selectedSystem, this.futureActionsOnOldSystemThatBelongsToNewSystem,this.futureActionsOnNewSystem )
    if (this.isReplaceAction) {
      //console.log("ifff___", this.isReplaceAction)
      //console.log("isreplace",this.selectedSystem, this.futureActionsOnOldSystemThatBelongsToNewSystem,this.futureActionsOnNewSystem )
      if (this.selectedSystem !== undefined && this.futureActionsOnOldSystemThatBelongsToNewSystem !== undefined &&  this.futureActionsOnNewSystem !== undefined) {
      
        return !this.futureActionsOnOldSystemThatBelongsToNewSystem.ShouldAllowToPerform || !this.futureActionsOnNewSystem.ShouldAllowToPerform;
      }   else {
        //console.log("else_if",this.action.ReplaceComponentCompartId, this.action.NewSMU ,this.action.MakeId ,this.action.BudgetLife, this.action.ExtendedBudgetLife )
        return !( this.action.ReplaceComponentCompartId !== 0 && this.action.ReplaceComponentCompartId !== undefined && this.action.ReplaceComponentCompartId !== null && this.action.NewSMU !== null && this.action.NewSMU !== undefined && this.action.MakeId !== undefined && this.action.BudgetLife !== undefined && this.action.ExtendedBudgetLife !== undefined);
      }
    } else
    if ( +this.action.ActionTypeId === 10602 || +this.action.ActionTypeId === 17 || +this.action.ActionTypeId === 10702 ) {
      //console.log("else___", this.action.ActionTypeId)
      return !(this.action.NewEqUnitId !== undefined && this.action.NewEqUnitId !== null && this.action.NewEqUnitId !== 0 && this.action.NewSMU !== undefined && this.action.NewSMU !== null);
    }
    return !(this.action.NewSMU !== 0 && this.action.NewSMU !== null && this.action.NewSMU !== undefined && this.action.ActionTypeId !== 0 && this.action.ActionTypeId !== undefined && this.action.ActionTypeId !== null && this.action.NewSMU !== undefined && this.action.NewSMU !== null);
  }

  selectedComponentReplacement(event) {
    this.action.ReplaceComponentCompartId = event.value.Id;
    this.action.ReplaceComponentCompartName = event.value.Name;

  }

  pickedEventDate(event) {
    this.action.ActionDate = event;
  }



  public getMultipleReplacementVaild(): boolean {
    if (this.repalceMutipleComponentsView !== undefined) {
      return this.repalceMutipleComponentsView.isVaild();
    }
    return false;
  }

  GoToEquipmentDetails() {
    // const currentActionEquipmentId = this.action.EquipmentId;

   // this._router.navigate(['/equipment/',  this.equipmentId]);
    this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
      if(res=="True"){
        this._router.navigate(['/equipment/',  this.equipmentId]);
      }else{             
        window.open('/equipment/' + this.equipmentId, '_blank');
       
      }
  });
  }


  EnterANewAction() {
    const currentActionEquipmentId = this.action.EquipmentId;
    this.replacementSucessful = false;
    this.isReplacingMultipleComponentsAtOnce = false;
    this.action = new GeneralActionViewModel();
    this.action.EquipmentId = currentActionEquipmentId;
    this.succesfullySubmitted = false;
    this._selectedIndex = 0;
    this.unlockAction();
  }



  additionalStepNext() {
    this._loadingService.startLoading();
    this._actioning  = true;
    const data = this.repalceMutipleComponentsView.reStructuredData;
    const componentIds = [];
    for (let i = 0; i < data.length; i++ ) {
      if ( (<ReplacingComponentsOnSystemViewModel>data[i]).GeneralEqUnitId !== undefined  ) {
        componentIds.push(<ReplacingComponentsOnSystemViewModel>data[i]);
      }
    }

    const actionDate = this.repalceMutipleComponentsView.actionDate;
    const smuAtReplacement = this.repalceMutipleComponentsView.actionAtEquipmentSMU;
    const rightDate = new Date(actionDate);


    const request = new MultipleComponentActionRequest(actionDate, this.equipmentId, smuAtReplacement, componentIds, rightDate.toLocaleDateString('en-US'));

    this._actionService.MultipleComponentReplacement(request).subscribe(r => {
      this._actioning  = false;
      this._loadingService.finishedLoading();
      if (r.OperationSucceed) {
        this.replacementSucessful = true;
        this._notification.success('Components Replaced Sucessfully');
      }       else {
        this._notification.error(r.Message);
      }
    });


  }
}
